import Column from "./components/atoms/Column";
import HeroText from "./components/atoms/HeroText";
import { DownIcon } from "./components/molecules/DownIcon";
import Page from "./components/atoms/Page";
import { SocialIconsBar } from "./components/molecules/SocialIconsBar";
import { About } from "./components/organisms/About";
import { Experience } from "./components/organisms/Experience";
import config from "./config";
import { Skills } from "./components/organisms/Skills";
import { Resume } from "./components/organisms/Resume";
import { Footer } from "./components/molecules/Footer";

function App() {
  return (
    <Page>
      <section id="hero">
        <SocialIconsBar />
        <Column>
          <HeroText>hi, i am {config.name}</HeroText>
          <HeroText>{config.profile}</HeroText>
        </Column>
        <DownIcon />
      </section>
      <section id="about">
        <About />
      </section>
      <section id="experience">
        <Experience />
      </section>
      <section id="skills">
        <Skills />
      </section>
      <section id="resume" style={{ position: "relative" }}>
        <Resume />
        <Footer />
      </section>
    </Page>
  );
}

export default App;
